import classNames from 'classnames';
import s from '#components/transition/collapse/collapse.module.scss';
import { FC, ReactNode } from 'react';

type Props = {
  open?: boolean;
  children: ReactNode;
  id?: string;
};

const Collapse: FC<Props> = ({ open, children, id }) => {
  const blockClass = classNames(s.host, {
    [s.open]: open,
  });

  return (
    <div id={id} className={blockClass}>
      <div className={s.inner}>{children}</div>
    </div>
  );
};

export default Collapse;
